window.dataLayer = window.dataLayer || [];
var site = site || {};
var randomPrize = randomPrize || {};

(function ($) {
  var $document = $(document);

  Drupal.behaviors.spinGameV1 = {
    attach: function (context) {
      // Properties
      var _spinningActive = false;
      var _tries = 0;
      var _currentTry = 0;
      var wheelSpinDuration = 5000; // Time in seconds corresponds to animation duration defined in SCSS
      var wheelZoomDuration = 1000; // Time in seconds corresponds to animation duration defined in SCSS
      var gameResetDelay = 500;
      var isMobile = Unison.fetch.now().name === 'small';
      var $spinGameContainer = $('.js-spin-game-v1', context);
      var $playNowBtn = $('.js-spin-game-play-now', $spinGameContainer);
      var $playAgain = $('.js-spin-game-play-again', $spinGameContainer);
      var $spinWheelWrapper = $('.js-spin-game-wheel-wrapper', $spinGameContainer);
      var $offerImages = $spinGameContainer.attr('data-spin-game-offer-images') || '';
      var $shopNowUrls = $spinGameContainer.attr('data-spin-game-shop-now-urls') || '';
      var $offerDescriptions = $spinGameContainer.attr('data-spin-game-offer-descriptions') || '';
      var $spinWheelContainier = $('.js-spin-game-container', $spinGameContainer);
      var $winningOfferImage = $('.js-spin-game-prize-image', $spinGameContainer);
      var $winningOfferDetail = $('.js-spin-game-prize-detail', $spinGameContainer);
      var $remainingSpins = $('.js-spin-game-remaining-spins', $spinGameContainer);
      var $applyOfferBtn = $('.js-apply-offer', $spinGameContainer);
      var isOfferRedeemed = false;
      var shapeOrder = $spinWheelContainier.attr('data-shape-order') || null;
      var shapesArray = shapeOrder && shapeOrder.length ? shapeOrder.split(',') : [];
      var spinWheelTranslate = isMobile ? 'translate(-50%, 0) ' : '';
      var spinWheelParams = {
        randomNumber: 0,
        perSpinAngle: 360,
        minimumCompleteSpins: parseInt($spinGameContainer.attr('minimum_complete_spins'), 10) || 2,
        newSpinAngle: 0,
        perSliceAngle: 30
      };
      var sliceCount = $spinGameContainer.attr('data-spin-game-slice-count') || 12;

      /**
       * Calculate Spin wheel resulting position
       *
       * @returns {bool} false
       */
      function calculateSpinResultPosition() {
        spinWheelParams.randomNumber = ensureRandomNumber(sliceCount, 0);
        spinWheelParams.spinSliceIndex = spinWheelParams.randomNumber - 1;
        spinWheelParams.minCompletedAngle =
          spinWheelParams.minimumCompleteSpins * spinWheelParams.perSpinAngle;
        spinWheelParams.newSpinAngle =
          spinWheelParams.minCompletedAngle +
          (spinWheelParams.perSpinAngle -
            spinWheelParams.perSliceAngle * spinWheelParams.spinSliceIndex);
        spinWheelParams.currentSlice = shapesArray[spinWheelParams.spinSliceIndex];
      }

      /**
       * On Click Function for the Play Button
       *
       * @returns {bool} false
       */
      function playGame() {
        if ($(this).hasClass('disabled')) {
          return;
        }
        // If the user has already played and also if try
        // count reached threshold then display message and exit
        if (isAlreadyPlayed() && _currentTry >= _tries) {
          alreadyPlayedPopup();

          return;
        }
        if (_spinningActive) {
          return;
        }
        _spinningActive = true;
        _currentTry += 1;

        // Show remaining spins count below play again button
        showRemainingSpins();
        randomPrize.setNumberOfTriesCookie(1);

        // Once play game / play again CTA is clicked, calculate new prize
        if (randomPrize.isGameValidforPlay()) {
          randomPrize.setPrize(randomPrize.offer_array, randomPrize.offer_probability);
          randomPrize.getPrize();
          randomPrize.setWinningOfferCookie(randomPrize.winning_offer.offer_code);
        }

        // Okay now play the game
        calculateSpinResultPosition();
        $spinGameContainer.addClass('spin-game--spin-started');

        // Slight delay is required before we start rotating the wheel
        setTimeout(function () {
          $spinWheelWrapper
            .css({
              transform: 'rotate(' + spinWheelParams.newSpinAngle + 'deg)'
            })
            .attr({
              'data-current-slice': spinWheelParams.currentSlice
            });
        }, 100);

        setTimeout(function () {
          $spinGameContainer.addClass('spin-game--spin-completed spin-game--zoom-started');
          $spinWheelWrapper.css({
            transform: spinWheelTranslate + 'rotate(' + spinWheelParams.newSpinAngle + 'deg)'
          });
          setTimeout(function () {
            var willWin = randomPrize.winOrNoWin();

            $spinGameContainer.addClass('spin-game--zoom-completed');
            showResult(willWin);
          }, wheelZoomDuration);
        }, wheelSpinDuration);
      }

      /**
       * Reset the spin wheel animations
       *
       * @returns {boolean} false
       */
      function resetSpinWheel() {
        var $activeSlice = $('.active-slice', context);

        $spinGameContainer.addClass('spin-game--spin-reset');
        $spinGameContainer
          .removeClass(
            'spin-game--spin-started spin-game--spin-completed spin-game--zoom-started spin-game--prize-reveal'
          )
          .removeClass(
            'spin-game--zoom-completed spin-game--fade-started spin-game--fade-completed spin-game--completed'
          )
          .removeClass('spin-game--already-played');
        if (isMobile) {
          $activeSlice.show();
        }
        $activeSlice.removeClass('active-slice');
        $spinWheelWrapper.css({
          transform: 'rotate(0deg)'
        });
        $spinGameContainer.removeClass('spin-game--spin-reset');
        $winningOfferImage.attr('src', '');
      }

      /**
       * When play again button is clicked, reset the spin wheel animations
       * and automatically start the spin again
       *
       * @returns {boolean} false
       */
      function resetAndPlayGame() {
        resetSpinWheel();
        $('html, body').animate({ scrollTop: 0 }, 50);
        // Short delay to allow the animations to reset
        setTimeout(playGame, gameResetDelay);
      }

      /**
       * Generates a random number but insure it's not one found within an array
       *
       * @param {number} max - Max number to generate
       * @param {number} excludeNumber - Number to ignore from the random number generated.
       * We can ignore 5 or 6, etc., from the range of numbers generated or by default 0 can be ignored
       *
       * @returns {number} Random number
       */
      function ensureRandomNumber(max, excludeNumber) {
        var exclude = excludeNumber || 0;
        var num = Math.floor(Math.random() * max);

        if (exclude === num) {
          return ensureRandomNumber(max, exclude);
        }

        return num;
      }

      /**
       * Show active slice in the result screen
       *
       * @param {boolean} $willWin - Win or No win based on chances of win per turn defined in CMS
       * @returns {boolean} false
       */
      function showResult($willWin) {
        var $currentWinningSlice = null,
          offerCode = randomPrize.winning_offer.offer_code || 'none';
        var winningOfferInfo = randomPrize.getWinningOffer();

        _spinningActive = false;
        // Have they won
        if (_currentTry >= _tries || $willWin) {
          if (typeof winningOfferInfo.winning_offer !== 'undefined') {
            offerCode = winningOfferInfo.winning_offer.offer_code;
            $currentWinningSlice = $(
              '.js-spin-game-' + spinWheelParams.currentSlice + '-shape',
              $spinGameContainer
            );
            randomPrize.setCookie(
              'game_winning_slice',
              spinWheelParams.currentSlice,
              randomPrize.overrideGameEnableTime() || 24
            );
            if ($currentWinningSlice.length) {
              $currentWinningSlice.addClass('active-slice');
            }
            $spinGameContainer.addClass('spin-game--fade-started');
            setTimeout(function () {
              $spinGameContainer.addClass('spin-game--fade-completed');
              showWinBox(winningOfferInfo);
            }, 1000);
          }
        }
        randomPrize.setWinningOfferCookie(offerCode);
        randomPrize.set24HourCookie(1);
      }

      /**
       * Shows the result screen
       *
       * @param {Object} $fields - fields used to populate the result screen
       * @returns {bool} false
       */
      function showWinBox($fields) {
        var offerDescriptionValue = $offerDescriptions.trim(),
          offerDescriptionArray = [],
          offerCode = '',
          index = 0,
          offerImagesValue = $offerImages.trim(),
          offerImagesArray = [],
          $currentWinningSlice,
          winningSlice,
          confirmMessage,
          winningOffer;

        // If there is no param this will not work
        if (!$fields || !$fields.winning_offer) {
          return false;
        }
        // Set the win box that the game will use
        // Populate the fields of the win box
        if (!$fields.playAgain) {
          $playAgain.addClass('hidden');
        }
        winningSlice = randomPrize.getCookie('game_winning_slice');
        $currentWinningSlice = $('.js-spin-game-' + winningSlice + '-shape', $spinGameContainer);
        $currentWinningSlice.addClass('active-slice');
        winningOffer = randomPrize.getWinningOffer().winning_offer;
        offerCode = winningOffer.offer_code;
        confirmMessage = winningOffer.confirm_message;
        index = randomPrize.offer_array.indexOf(offerCode);

        // inject winning offer description
        if (offerDescriptionValue.length) {
          offerDescriptionArray = offerDescriptionValue.split('^===^');
          $winningOfferDetail.html(offerDescriptionArray[index]);
        }
        // inject winning offer image
        if (offerImagesValue.length) {
          offerImagesArray = offerImagesValue.split('^===^');
          $winningOfferImage.attr('src', offerImagesArray[index]);
        }
        $spinGameContainer.addClass('spin-game--prize-reveal');
        if (isMobile) {
          $currentWinningSlice.hide();
        }
        // If the override flag is set then display the offer confirmation
        // message in the success popup
        if (randomPrize.overrideSuccessContent) {
          randomPrize.nodes.successOverlayCopy.html(confirmMessage);
        }
        setTimeout(function () {
          $spinGameContainer.addClass('spin-game--completed');
        }, 1400);
      }

      /**
       * Show the remaining Spins under the spin button
       *
       * @returns {boolean} false
       */
      function showRemainingSpins() {
        var remainingSpins = _tries - _currentTry;
        var msgAttributeName =
          remainingSpins !== 1 ? 'data-spins-remaining-plural' : 'data-spins-remaining-singular';
        var remainingSpinsMessage = $remainingSpins.attr(msgAttributeName);

        if (remainingSpinsMessage && remainingSpinsMessage.length) {
          $remainingSpins.html(
            remainingSpinsMessage.replace('::REMAINING_SPINS_COUNT::', remainingSpins)
          );
        }
      }
      /**
       * On Redeem/Shop now CTA click
       *
       * @returns {boolean} false
       */
      function shopNowRedirect() {
        var shopNowUrlValues = $shopNowUrls.trim(),
          shopNowUrls,
          offerCode,
          url;

        if (shopNowUrlValues.length) {
          shopNowUrls = shopNowUrlValues.split('^===^');
          offerCode = randomPrize.getWinningOffer().winning_offer.offer_code;
          url = shopNowUrls[randomPrize.offer_array.indexOf(offerCode)];
          location.href = url;
        }
      }

      /**
       * Check if the user has already played
       * the game
       *
       * @returns {boolean} false
       */
      function isAlreadyPlayed() {
        return randomPrize.getWinningOfferCookie() && randomPrize.get24HourCookie();
      }

      /**
       * If the user has played the game, then show them the result screen
       * If the user has lost the game, then show game lost message
       *
       * @returns {boolean} false
       */
      function alreadyPlayedPopup() {
        var offerCodeCookie = randomPrize.getWinningOfferCookie();
        var displayInactiveOverlay =
          randomPrize.settings.showGameInactiveOverlay.length > 0
            ? parseInt(randomPrize.settings.showGameInactiveOverlay, 10)
            : 0;

        if (
          randomPrize.nodes.inactiveOverlayContainer &&
          displayInactiveOverlay &&
          randomPrize.getCookie('game_offer_applied')
        ) {
          randomPrize.gameInactiveOverlay();
          $playAgain.add($remainingSpins).addClass('hidden');
        }
        if (offerCodeCookie !== 'none') {
          $spinGameContainer.addClass('spin-game--already-played');
          showWinBox(randomPrize.getWinningOffer());
        }
      }

      /**
       * Initiate randomizer game when this
       * template loads
       *
       * @returns {boolean} false
       */
      function initRandomPrize() {
        var displaySuccessOverlay;

        randomPrize.stopGameFor24HoursOnceWon = 0;
        randomPrize.getPrizeOnPageLoad = false;
        randomPrize.init();

        _tries = randomPrize.settings.numberOfTries;
        _currentTry = parseInt(randomPrize.getNumberOfTriesCookie(), 10);
        isOfferRedeemed = parseInt(randomPrize.getCookie('game_offer_applied'), 10);
        if (!isOfferRedeemed) {
          $applyOfferBtn.removeClass('hidden');
        }

        $.when(randomPrize.offerApplied).then(function () {
          displaySuccessOverlay =
            randomPrize.settings.showSuccessOverlay.length > 0
              ? parseInt(randomPrize.settings.showSuccessOverlay, 10)
              : 0;
          randomPrize.setCookie(
            'game_offer_applied',
            1,
            randomPrize.overrideGameEnableTime() || 24
          );
          randomPrize.set24HourCookie(1);
          if (displaySuccessOverlay) {
            randomPrize.successOverlay();
            $applyOfferBtn.addClass('hidden');
            $playAgain.add($remainingSpins).addClass('hidden');
          } else {
            shopNowRedirect();
          }
        });

        $.when(randomPrize.GameReady).then(function () {
          $('html, body').animate({ scrollTop: 0 }, 500);
          if (isOfferRedeemed || isAlreadyPlayed() || _currentTry >= _tries) {
            randomPrize.hideLoading();
            alreadyPlayedPopup();
          }
          showRemainingSpins();
        });
      }

      /**
        Show success overlay once offer is applied
        @returns {boolean} false
      **/
      function onOfferAppliedResolve() {
        var displaySuccessOverlay =
          randomPrize.settings.showSuccessOverlay.length > 0
            ? parseInt(randomPrize.settings.showSuccessOverlay, 10)
            : 0;

        randomPrize.setCookie('game_offer_applied', 1, randomPrize.overrideGameEnableTime() || 24);
        randomPrize.set24HourCookie(1);
        if (displaySuccessOverlay) {
          randomPrize.successOverlay();
          $applyOfferBtn.addClass('hidden');
          $playAgain.add($remainingSpins).addClass('hidden');
        } else {
          shopNowRedirect();
        }
      }
      /**
       * Callback function that executes once offer has been removed
       * @returns {boolean} false
       */
      function onOfferRemoval() {
        var $container = $('.js-game-inactive-overlay-bg, .js-game-success-popup-overlay', context);
        var $removeOfferButton = $('.js-remove-offer', $container);
        var $addOfferButton = $('.js-add-offer', $container);
        var successUrl = $removeOfferButton.data('successUrl').trim();

        randomPrize.deleteCookie('game_offer_applied');
        if (successUrl) {
          window.location.href = successUrl;
        }
        $addOfferButton.removeClass('hidden');
        $removeOfferButton.addClass('hidden');
      }

      $(window).on(
        'resize',
        _.debounce(function () {
          isMobile = Unison.fetch.now().name === 'small';
          spinWheelTranslate = isMobile ? 'translate(-50%, 0) ' : '';
        }, 100)
      );

      $playNowBtn.on('click', playGame);
      $playAgain.on('click', resetAndPlayGame);
      $('html, body').animate({ scrollTop: 0 }, 500);
      initRandomPrize();
      $document
        .on('game.randomizer.offer.remove.success', onOfferRemoval)
        .on('game.randomizer.offer.applied.success', onOfferAppliedResolve);
    }
  };
})(jQuery);
